// extracted by mini-css-extract-plugin
export default {"header":"table-content_header__PVNC9"};